// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "async/" + chunkId + "." + {"254": "60e7740d","852": "356235eb",}[chunkId] + ".css"
}